import React from 'react';
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import { CONSTRUCTION_SITE_PHOTOS } from '../../data/constructionSitePhotos';

const heroImg = CONSTRUCTION_SITE_PHOTOS[3];
const img1 = CONSTRUCTION_SITE_PHOTOS[5];
const img2 = CONSTRUCTION_SITE_PHOTOS[7];
const img3 = CONSTRUCTION_SITE_PHOTOS[9];

function About() {
  return (
    <main className="bg-white">
      <Helmet>
        <title>About | MA Renovations</title>
        <meta name="description"
          content="MA Renovations is a construction company delivering new build, structural, and fit-out work for architects, consultants, and developers in Glasgow." />
      </Helmet>

      <div className="pt-36 sm:pt-40 pb-8 px-6 max-w-5xl mx-auto">
        <h1 className="font-display text-3xl sm:text-4xl text-navy font-bold tracking-tight">About us</h1>
        <p className="mt-2 text-slate-500">Construction delivery with architect and consultant collaboration.</p>
      </div>

      <section className="max-w-5xl mx-auto px-6 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {heroImg && (
          <div className="aspect-[4/3] overflow-hidden rounded">
            <img className="w-full h-full object-cover" src={heroImg} alt="Construction site" />
          </div>
          )}
          <div>
            <h2 className="font-display text-2xl text-navy font-bold">Who we are</h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              MA Renovations is a construction company focused on new build, structural works, commercial projects, and interior fit-out. We work with architects, engineers, and clients to move projects from pre-construction through to handover — with clear communication and disciplined site management.
            </p>
            <p className="mt-3 text-slate-600 leading-relaxed">
              We care about buildability, programme realism, and protecting design intent when details meet site conditions.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mb-16">
          <div className="p-6 rounded border border-slate-200">
            <h3 className="font-display font-semibold text-navy">Coordination</h3>
            <p className="text-slate-500 text-sm mt-2">We align trades, hold points, and consultant inspections so design decisions are reflected in what is built.</p>
          </div>
          <div className="p-6 rounded border border-slate-200">
            <h3 className="font-display font-semibold text-navy">Health & safety</h3>
            <p className="text-slate-500 text-sm mt-2">Safe sites are productive sites. We plan logistics, temporary works, and access with clear responsibilities.</p>
          </div>
          <div className="p-6 rounded border border-slate-200">
            <h3 className="font-display font-semibold text-navy">Dependable delivery</h3>
            <p className="text-slate-500 text-sm mt-2">Predictable communication, documented changes, and a handover process that doesn't leave loose ends.</p>
          </div>
        </div>

        <h2 className="font-display text-2xl text-navy font-bold text-center mb-8">Project photography</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {[img1, img2, img3].filter(Boolean).map((src, i) => (
            <div key={i} className="aspect-[4/3] overflow-hidden rounded">
              <img className="w-full h-full object-cover" src={src!} alt="Construction project" />
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/projects/construction" onClick={() => {window.scrollTo({top: 0,})}}>
            <button className="px-10 py-3 bg-accent text-white rounded font-semibold hover:bg-accent-dark transition-colors" type="button">View projects</button>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default About;
